import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsers,
  faPaste,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";

import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import { Configurations } from "./Configurations";
import Security from "./Security";
import Administracion from "./Administracion";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

const NavLinks = ({ drawerIsOpen }) => {
  let rout = getRuta();
  const { access } = useContext(DataContext);

  return (
    <div style={{ overflow: "hidden" }}>
      <Stack spacing={0.3} justifyContent="flex-start">
        <Typography
          sx={{
            color: sidebar.sectionColor,
            fontSize: 11,
            textTransform: "uppercase",
            letterSpacing: ".08em",
            padding: "6px 10px 4px",
          }}
        >
          General
        </Typography>

        <NavItem
          to={`${rout}/`}
          end
          icon={<FontAwesomeIcon icon={faHome} fontSize="inherit" />}
          label="Panel Principal"
        />

        {isAccess(access, "CLIENTS VER") ? (
          <NavItem
            to={`${rout}/clients`}
            icon={<FontAwesomeIcon icon={faUsers} fontSize="inherit" />}
            label="Clientes"
          />
        ) : null}

        {isAccess(access, "CREDITS VER") ? (
          <NavItem
            to={`${rout}/credits`}
            icon={<FontAwesomeIcon icon={faCreditCard} fontSize="inherit" />}
            label="Créditos"
          />
        ) : null}

        {isAccess(access, "REPORTS VER") || isAccess(access, "ADMON VER") ? (
          <Typography
            sx={{
              color: sidebar.sectionColor,
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: ".08em",
              padding: "16px 10px 4px",
            }}
          >
            Gestión
          </Typography>
        ) : null}

        {isAccess(access, "REPORTS VER") ? (
          <NavItem
            to={`${rout}/reports`}
            icon={<FontAwesomeIcon icon={faPaste} fontSize="inherit" />}
            label="Reportes"
          />
        ) : null}

        {isAccess(access, "ADMON VER") ? (
          <Administracion drawerIsOpen={drawerIsOpen} />
        ) : null}

        {isAccess(access, "SECURITY VER") || isAccess(access, "CONFIG VER") ? (
          <Typography
            sx={{
              color: sidebar.sectionColor,
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: ".08em",
              padding: "16px 10px 4px",
            }}
          >
            Sistema
          </Typography>
        ) : null}

        {isAccess(access, "SECURITY VER") ? (
          <Security drawerIsOpen={drawerIsOpen} />
        ) : null}

        {isAccess(access, "CONFIG VER") ? (
          <Configurations drawerIsOpen={drawerIsOpen} />
        ) : null}
      </Stack>
    </div>
  );
};

export default NavLinks;
